function validateItem({ image, name, url, id }) {
    return !!(image && name && url && id);
}

function normalizeCollection(collection) {
    const validCollection = collection.filter(validateItem);
    return validCollection.map((item) => {
        const normalizedItem = { ...item, id: parseInt(item.id, 10) };
        if (item.url) {
            normalizedItem.relativePath = item.url.replace(process.env.baseUrl, '');
        }
        return normalizedItem;
    });
}

function normalizeBlockData({ header: title, data = [] }) {
    return { title, collection: normalizeCollection(data) };
}

function normalizeSquareBanners(squareBanner) {
    return squareBanner
        .filter(({ header, description, banner, url }) => header && description && banner && url)
        .map(({ header: title, description, banner, url }) => ({
            title,
            description,
            banner,
            url,
        }));
}

function normalizeSingleBanner({ url, images: imagesWithoutType }) {
    const images = [];
    Object.keys(imagesWithoutType).forEach((type) => {
        images.push({
            type,
            src: imagesWithoutType[type],
        });
    });

    return {
        url,
        images,
    };
}

function normalizeArticle({ header: title, data }) {
    const { short_description: shortDescription, description } = data;
    return {
        title,
        shortDescription,
        description,
    };
}

function normalizeMiniHeroBanner(miniHeroBanners) {
    try {
        const banners = miniHeroBanners.map((item) => {
            const { image: img, url } = item;
            return {
                img,
                url,
            };
        });

        return {
            leftSlots: [banners[0]],
            rightSlots: [banners[1]],
        };
    } catch {
        return {
            leftSlots: [],
            rightSlots: [],
        };
    }
}

export default function ({
    category,
    inspiration,
    mini_hero_banner: miniHeroBanners,
    square_banner: squareBanner,
    row_banner: rowBanner,
    hero_banner: heroBanner,
    article,
    custom_html: customHtml,
    custom_head_html: customHeadHtml,
}) {
    return {
        category: normalizeBlockData(category),
        inspiration: normalizeBlockData(inspiration),
        miniHeroBanner: normalizeMiniHeroBanner(miniHeroBanners),
        squareBanner: normalizeSquareBanners(squareBanner),
        rowBanner: normalizeSingleBanner(rowBanner),
        heroBanner: normalizeSingleBanner(heroBanner),
        article: normalizeArticle(article),
        customHtml,
        customHeadHtml,
    };
}
